import {
    Building2,
    Calendar,
    DollarSign,
    FileCheck,
    Users
} from 'lucide-react';
import React from 'react';
import { useQuery } from 'react-query';
import api from '../../services/api';

const Dashboard = () => {
  // 대시보드 데이터 가져오기
  const { data: dashboardData, isLoading } = useQuery('dashboard', async () => {
    try {
      console.log('🔍 메인 대시보드 데이터 로드 시작');
      const response = await api.get('/dashboard');
      console.log('📊 메인 대시보드 응답:', response);
      return response;
    } catch (error) {
      console.error('❌ 대시보드 데이터 로드 실패:', error);
    }

    // 기본값 반환
    return {
      totalBuildings: 0,
      totalTenants: 0,
      activeContracts: 0,
      monthlyIncome: 0,
      recentActivities: [],
      upcomingPayments: [],
      overduePayments: []
    };
  });

  const stats = [
    {
      name: '총 건물 수',
      value: dashboardData?.totalBuildings || 0,
      icon: Building2,
      color: 'bg-blue-500',
    },
    {
      name: '총 임차인 수',
      value: dashboardData?.totalTenants || 0,
      icon: Users,
      color: 'bg-green-500',
    },
    {
      name: '활성 계약',
      value: dashboardData?.activeContracts || 0,
      icon: FileCheck,
      color: 'bg-purple-500',
    },
    {
      name: '이번 달 수입',
      value: `₩${(dashboardData?.monthlyIncome || 0).toLocaleString()}`,
      icon: DollarSign,
      color: 'bg-yellow-500',
    },
  ];

  const recentActivities = dashboardData?.recentActivities || [];
  const upcomingPayments = dashboardData?.upcomingPayments || [];
  const overduePayments = dashboardData?.overduePayments || [];

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* 페이지 제목 */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">대시보드</h1>
        <p className="mt-1 text-sm text-gray-500">
          임대관리 현황을 한눈에 확인하세요
        </p>
      </div>

      {/* 통계 카드 */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((stat) => {
          const Icon = stat.icon;
          return (
            <div
              key={stat.name}
              className="bg-white overflow-hidden shadow rounded-lg"
            >
              <div className="p-5">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div className={`w-8 h-8 rounded-md flex items-center justify-center ${stat.color}`}>
                      <Icon className="w-5 h-5 text-white" />
                    </div>
                  </div>
                  <div className="ml-5 w-0 flex-1">
                    <dl>
                      <dt className="text-sm font-medium text-gray-500 truncate">
                        {stat.name}
                      </dt>
                      <dd className="text-lg font-medium text-gray-900">
                        {stat.value}
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* 주요 섹션들 */}
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        {/* 최근 활동 */}
        <div className="bg-white shadow rounded-lg">
          <div className="px-4 py-5 sm:p-6">
            <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
              최근 활동
            </h3>
            <div className="space-y-4">
              {recentActivities.length > 0 ? (
                recentActivities.map((activity, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <div className="flex-shrink-0">
                      <div className="w-2 h-2 bg-primary-600 rounded-full mt-2"></div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm text-gray-900">{activity.description}</p>
                      <p className="text-xs text-gray-500">
                        {new Date(activity.created_at).toLocaleDateString('ko-KR')}
                      </p>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-sm text-gray-500">최근 활동이 없습니다.</p>
              )}
            </div>
          </div>
        </div>

        {/* 다가오는 결제 */}
        <div className="bg-white shadow rounded-lg">
          <div className="px-4 py-5 sm:p-6">
            <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
              다가오는 결제
            </h3>
            <div className="space-y-4">
              {upcomingPayments.length > 0 ? (
                upcomingPayments.map((payment, index) => (
                  <div key={index} className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                      <Calendar className="w-4 h-4 text-gray-400" />
                      <div>
                        <p className="text-sm font-medium text-gray-900">
                          {payment.tenant_name}
                        </p>
                        <p className="text-xs text-gray-500">
                          {payment.building_name} - {payment.unit_number}
                        </p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="text-sm font-medium text-gray-900">
                        ₩{payment.amount.toLocaleString()}
                      </p>
                      <p className="text-xs text-gray-500">
                        {new Date(payment.due_date).toLocaleDateString('ko-KR')}
                      </p>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-sm text-gray-500">다가오는 결제가 없습니다.</p>
              )}
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Dashboard;


